import { render, staticRenderFns } from "./modal-view-document.vue?vue&type=template&id=21d04d4a&scoped=true&lang=pug"
import script from "./modal-view-document.js?vue&type=script&lang=js&external"
export * from "./modal-view-document.js?vue&type=script&lang=js&external"
import style0 from "./modal-view-document.vue?vue&type=style&index=0&id=21d04d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d04d4a",
  null
  
)

export default component.exports